import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CerrixInstructionsIconComponent } from "@app/shared/cerrix-instructions-icon/cerrix-instructions-icon.component";
import { SharedModule } from "@app/shared/shared.module";
import { WeekdayModel } from "@app/workday-organizer/models/weekday-model";

@Component({
    selector: "working-days",
    imports: [SharedModule, CerrixInstructionsIconComponent],
    templateUrl: "./working-days.component.html",
    styleUrl: "./working-days.component.scss"
})
export class WorkingDaysComponent {
    private _workingDays: string[] = [];
    public get workingDays(): string[] {
        return this._workingDays;
    }
    @Input() public set workingDays(value: string[]) {
        this._workingDays = value;
        value.forEach((day) => {
            const localDay = this.workingDaysList.find((d) => d.shortName === day);
            if (localDay) {
                localDay.isSelected = true;
            }
        });
        this.isLoaded = true;
    }

    @Output() public isDirtyChange: EventEmitter<string[]> = new EventEmitter<string[]>();

    public workingDaysList: WeekdayModel[] = [
        { name: "Monday", shortName: "mo", isSelected: false },
        { name: "Tuesday", shortName: "tu", isSelected: false },
        { name: "Wednesday", shortName: "we", isSelected: false },
        { name: "Thursday", shortName: "th", isSelected: false },
        { name: "Friday", shortName: "fr", isSelected: false },
        { name: "Saturday", shortName: "sa", isSelected: false },
        { name: "Sunday", shortName: "su", isSelected: false },
    ];

    public isLoaded: boolean = false;

    onToggle() {
        this.workingDays = this.workingDaysList
            .filter((day) => day.isSelected)
            .map((day) => day.shortName);
        this.isDirtyChange.emit(this.workingDays);
    }
}
